import * as React from 'react';
import ReportRecipientLayout from './ReportRecipientLayout';
import LocalDiv from '../localization/LocalDiv';
import { css } from '@emotion/core';
import { FLEX_COLUMN, FLEX_ROW } from '../layout/flexBox';
import { btnStyle } from '../forms/styles/button';
import { COLORS } from '../globalStyle/colors';
import { onMobileDevice } from '../globalStyle/mediaQueries';
import { useCallback, useMemo } from 'react';
import { useToggle } from '../core/hooks/useToggle';
import { Loader } from '../loading/Loader';
import { useMount } from '../core/hooks/useMount';
import { useCurrentUser } from '../auth/hooks';
import { useDispatch } from 'react-redux';
import { SELECT } from '../forms/styles/select';
import { useAppState } from '../core/redux/hooks';
import { getDashboardDefaultsAction } from './api/getDashboardDefaultsAction';
import { openMenuAction } from '../project/sideMenu/openMenuAction';
import Msg from '../localization/Msg';
import { Str } from '../localization/translationKeys';//import { DashboardAssessment, DashboardClient } from './models';
import { isRtl } from '../localization/module';
//import LocalSelect from '../localization/LocalSelect';
//import { getDashboardClientsAction } from './api/getDashboardClientsAction';
//import { getDashboardAssessmentsAction } from './api/getDashboardAssessmentsAction';
//import { getDashboardDatesAction } from './api/getDashboardDatesAction';
//import LocalBtn from '../localization/LocalBtn';

const styles = {
  header: css`
    margin: 20px auto 40px;
    font-size: 26px;
    
    ${onMobileDevice} {
      padding-top: 25px;
    }
  `,
  reportContent: css`
    margin-top: 0;
  `,  
  titleTop: css`
    font-weight: bold;
    margin: 0 0 5px;
  `,
  title: css`
    font-weight: bold;
    margin: 20px 0 5px;
  `,
  btnRow: {
    root:        [
      FLEX_ROW,
      css`
        justify-content: flex-end;
        margin-top: 12px;
      `,
    ],
    viewBtn: btnStyle.primary(COLORS.BLUE),
  },
  icon: css`
    padding-top: 10px;
  `,
  linkDisabled:       css`
    cursor: default;
    opacity: .6;

    &:hover { 
      text-decoration: none;
      cursor: default;
    }
  `,
  iframe:        css`
    width: 100%;
    height: calc(100vh - 53px);
  `, 
  loader:        css`
    width: 150px;
    height: 150px;
    margin: auto;
  `, 
  loadMsg:        css`
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  `,   
  dateInput:        css`
    height: 35px;
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid #C8C8C8;
  `, 
  table:             css``,
  selectContainer:   {
    root:    FLEX_COLUMN,
    caption: css``,
    select:  SELECT,
  },
};


type Props = {
  className?: string;
}

// const mapClientsToOptions = (
//   clients: DashboardClient[],
// ) => clients.map(
//   p => (
//     <option
//       key={p.clientId}
//       value={p.clientId}
//       label={p.name}
//     >
//       {p.name}
//     </option>
//   ),
// );

// const mapAssessmentsToOptions = (
//   assessments: DashboardAssessment[],
// ) => assessments.map(
//   p => (
//     <option
//       key={p.assessmentId}
//       value={p.assessmentId}
//       label={p.name}
//     >
//       {p.name}
//     </option>
//   ),
// );

/**
 * ReportRecipientAggregateDashboard: a component that enables report recipients to see aggregate dashboard.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ReportRecipientAggregateDashboard: React.FC<Props> = props => {
  
  //const [needInitialValues, toggleInitialValues] = useToggle(false);
  const needInitialValues = false;
  const [loadingReport, toggleLoadingReport] = useToggle(true);

  const defaults = useAppState(state => state.dashboardDefaults);
  //const dates = useAppState(state => state.dashboardDates);
  //const clients = useAppState(state => state.dashboardClients || {});
  //const assessments = useAppState(state => state.dashboardAssessments || {});

  const currentUser = useCurrentUser();
  const userClientId = currentUser?.clientId || 0;

  const selectedClientId = React.useMemo(
    () => (
      defaults
      ? defaults.clientId
      : 0
    ),
    [defaults],
  );

  const selectedAssessmentId = React.useMemo(
    () => (
      defaults
      ? defaults.assessmentId
      : 0
    ),
    [defaults],
  );
  
  const startDate = React.useMemo(
    () => (
      defaults
      ? defaults.minDate
      : ''
    ),
    [defaults],
  );

  const endDate = React.useMemo(
    () => (
      defaults
      ? defaults?.maxDate
      : ''
    ),
    [defaults],
  ); 
  //const [selectedClientId, setSelectedClientId] = useState(defaults?.clientId || userClientId);
  //const [selectedAssessmentId, setSelectedAssessmentId] = useState(defaults?.assessmentId || 0);
  //const [startDate, setStartDate] = useState((new Date(new Date().getFullYear(), 0, 1)).toISOString().slice(0, 10));
  //const [endDate, setEndDate] = useState((new Date()).toISOString().slice(0, 10));

  const dispatch = useDispatch();
  useMount(() => {
    dispatch(getDashboardDefaultsAction(userClientId));
    //dispatch(getDashboardClientsAction(userClientId));
    //dispatch(getDashboardAssessmentsAction(userClientId, selectedClientId));
    // if (selectedClientId > 0 && selectedAssessmentId > 0) {
    //   dispatch(getDashboardDatesAction(userClientId, selectedClientId, selectedAssessmentId));
    //   if (dates) {
    //     setStartDate(dates.minDate.toUTCString);
    //     setEndDate(dates.maxDate.toUTCString);
    //   }
    // }
  });
  
  // const viewDisabled = React.useMemo(
  //   () => (
  //     selectedClientId === 0 || selectedAssessmentId === 0
  //   ),
  //   [selectedClientId, selectedAssessmentId],
  // );

  // const setClient = useCallback(
  //   (clientId: number) => {
  //     setSelectedClientId(clientId);
  //     dispatch(getDashboardAssessmentsAction(userClientId, clientId));
  //     if (assessments && assessments[0]) {
  //       setSelectedAssessmentId(assessments[0].assessmentId);
  //     }
  //     if (selectedAssessmentId > 0) {
  //       dispatch(getDashboardDatesAction(userClientId, clientId, selectedAssessmentId));
  //     }
  //   },
  //   [dispatch, userClientId, selectedAssessmentId, assessments],
  // );
  
  // const setAssessment = useCallback(
  //   (assessmentId: number) => {
  //     setSelectedAssessmentId(assessmentId);
  //     dispatch(getDashboardDatesAction(userClientId, selectedClientId, assessmentId));
  //   },
  //   [dispatch, userClientId, selectedClientId],
  // ); 

  // const dateRange = React.useMemo(
  //   () => (
  //     dates && dates.minDate && dates.maxDate
  //     ? new Date(dates.minDate).getFullYear() < 1900 || new Date(dates.maxDate).getFullYear() < 1900
  //       ? 'No data found for this assessment'
  //       : new Date(dates.minDate).toLocaleDateString() + ' to ' + new Date(dates.maxDate).toLocaleDateString()
  //     : 'Evaluated for selected client and assessment'
  //   ),
  //   [dates],
  // );

  // const viewClicked = () => {
  //   toggleInitialValues();
  //   toggleLoadingReport();
  // }  

  const locale = useAppState(state => state.locale);
  const languageId = locale.lang.languageId;
  const logiUrl   = useAppState(state => state.config?.logiUrl || '');

  const dashboardUrl = useCallback(
    () =>
      selectedClientId === 0 || selectedAssessmentId === 0 || !(startDate) || !(endDate)
      ? ''
      : `${logiUrl}/rdProcess.aspx?rdProcess=urlProcess&rdTaskId=tskReport&Report=TruScore.Dashboard&UserClientID=
        ${userClientId}&ClientID=${selectedClientId}&AssessmentID=${selectedAssessmentId}&DateFrom=${startDate}
        &DateTo=${endDate}&LanguageId=${languageId}`,
    [logiUrl, userClientId, selectedClientId, selectedAssessmentId, startDate, endDate, languageId],
  );  

  const checkMenu = () => {
    // Close the side menu when showing a web report to maximize space
    window.setTimeout(() => dispatch(openMenuAction(false)), 200);

    return true;
  };

  const rtl = useMemo(() => isRtl(locale.textDirection), [locale]);

  // const handleStartDateChange = (event: { target: { value: any; }; }) => {
  //   setStartDate(event.target.value);
  // };

  // const handleEndDateChange = (event: { target: { value: any; }; }) => {
  //   setEndDate(event.target.value);
  // };

  return (
    <ReportRecipientLayout
      floatMenu={checkMenu()}
      contentStyle={
        loadingReport
          ? css`padding: 70px 0 0 0;`
          : rtl
            ? css`padding: 0 50px 0 0;
                  max-width: 100%;`
            : css`padding: 0 0 0 50px;
                  max-width: 100%;`
      }
    >
      {/* {
        needInitialValues && (
          <>
            <LocalDiv css={styles.header}>
              <Msg str={Str.AggregateDashboard} />
            </LocalDiv>
            <LocalDiv css={styles.titleTop}>
              Initial Client
            </LocalDiv>
            <LocalSelect
              css={styles.selectContainer.select}
              onChange={event => setClient(+event.target.value)}
              value={selectedClientId}
            >
              {mapClientsToOptions(Object.values(clients))}
            </LocalSelect>
            <LocalDiv css={styles.title}>
              Initial Assessment
            </LocalDiv>
            <LocalSelect
              css={styles.selectContainer.select}
              onChange={event => setAssessment(+event.target.value)}
              value={selectedAssessmentId}
            >
              {mapAssessmentsToOptions(Object.values(assessments))}
            </LocalSelect>
            <LocalDiv css={styles.title}>
              Date Range of Available Data
            </LocalDiv>
            <LocalDiv>
              {dateRange}
            </LocalDiv>
            <LocalDiv css={styles.title}>
              Initial Start Date
            </LocalDiv>
            <LocalDiv>
              <input
                type="date"
                id="startDate"
                name="startDate"
                css={styles.dateInput}
                value={startDate}
                onChange={handleStartDateChange}
              />
            </LocalDiv>
            <LocalDiv css={styles.title}>
              Initial End Date
            </LocalDiv>
            <LocalDiv>
              <input
                type="date"
                id="endDate"
                name="endDate"
                css={styles.dateInput}
                value={endDate}
                onChange={handleEndDateChange}
              />
            </LocalDiv>
            <LocalDiv css={styles.btnRow.root}>
              {
                <LocalBtn
                  str={Str.ViewAggregateDashboard}
                  css={styles.btnRow.viewBtn}
                  onClick={viewClicked}
                  disabled={viewDisabled}
                />
              }
            </LocalDiv>
          </>
        )
      } */}
      {
        (loadingReport || dashboardUrl() === '') && (
          <>
            <Loader css={styles.loader} />
            <LocalDiv css={styles.loadMsg}>
              <Msg str={Str.DashboardLoadMessage} />
            </LocalDiv>  
          </>        
        )
      }
      {
        !needInitialValues && dashboardUrl() !== '' && (
          <iframe
            frameBorder={0}
            css={styles.iframe}
            src={dashboardUrl()}
            title='view-report'
            onLoad={
              () => {
                if (loadingReport) {
                  toggleLoadingReport();
                }
              }
            }
          />
        )
      }
    </ReportRecipientLayout>
  );
};

export default ReportRecipientAggregateDashboard;